<div class="row mt-2">
    <div class="col-md-6">
      <div class="card">
          <div class="card-header">
              <div class="card-title mb-0"><strong>Hook</strong></div>
          </div>
          <div class="card-body">
              <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="type" class="form-label">Type <em>*</em></label>
                            <select class="form-control" id="type" name="type" #type="ngModel" [(ngModel)]="data.type" required>
                                <option [value]="'footer'">Footer</option>
                                <option [value]="'dashboard-footer'">Dashboard Footer</option>
                            </select>
                            <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                                <div *ngIf="type.errors.required">Type is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="type" class="form-label">Language <em>*</em></label>
                            <select class="form-control" id="type" name="type" #type="ngModel" [(ngModel)]="data.type" required>
                                <option [value]="'en'">English</option>
                                <option [value]="'my'">Malay</option>
                                <option [value]="'cn'">Chinese</option>
                            </select>
                            <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                                <div *ngIf="type.errors.required">Type is required</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="from_date" class="form-label">Content <em>*</em></label>
                            <angular-editor id="content" [placeholder]="'Enter content'" [(ngModel)]="data.content" name="content" #content="ngModel" required></angular-editor>
                            <div *ngIf="f.submitted && content.invalid" class="invalid-feedback">
                                <div *ngIf="content.errors.required">Content is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="status" class="form-label">Status <em>*</em></label>
                            <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                                <option [value]="1">Active</option>
                                <option [value]="0">Disabled</option>
                            </select>
                            <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                <div *ngIf="status.errors.required">Status is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                  <button type="submit" class="btn btn-primary">Save</button>
              </form>
          </div>
      </div>
    </div>
  </div>